import React from 'react'

import Base from '../_Base'

const LockActive = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M8 8c0-2.206 1.794-4 4-4s4 1.794 4 4v2H8V8zm11 2h-1V8A6 6 0 0 0 6 8v2H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1z"
      fillRule="evenodd"
    />
  </Base>
)

export default LockActive
